import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { TextField, Button, CircularProgress, Box } from "@mui/material";
import { useLocation } from "react-router-dom";

const CustomTable = ({
  rows,
  columns,
  exportName,
  onSortModelChange,
  onPageChange,
  onPageSizeChange,
  onFilterModelChange,
  onPaginationModelChange,
  paginationModel,
  pageSize,
  pageSizeOptions,
  filterDel,
  filterCus,
  setFilterCus,
  filterOrder,
  setFilterDel,
  setFilterOrder,
  filterCol,
  setFilterCol,
  filterBill,
  setFilterBill,
  filterTax,
  setFilterTax,
  setFiltersApplied,
  filtersApplied,
  resetAlldel,
  resetAllcus,
  resetAllcol,
  resetAllbill,
  resetAlltax,
  rowCount,
  page,
  exportCallback,
  hideMobileNumber,
  resetAllOrder,
  disableSelectionOnClick,
  checkboxSelection,
  getRowHeight,
}) => {
  const [filters, setFilters] = React.useState({});
  const location = useLocation();

  const filteredRows = rows.filter((row) => {
    return Object.keys(filters).every((field) => {
      const filterValue = filters[field] || "";
      return row[field]
        ?.toString()
        .toLowerCase()
        .includes(filterValue.toLowerCase());
    });
  });

  const handleExport = () => {
    const csvRows = [];
    const filteredColumns = columns.filter(
      (column) => !["action", "internalCopy"].includes(column.field)
    );
    const headers = filteredColumns
      .map((column) => column.headerName)
      .join(",");
    csvRows.push(headers);

    filteredRows.forEach((row) => {
      const values = filteredColumns
        .map((column) => row[column.field] || "")
        .join(",");
      csvRows.push(values);
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${exportName}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    setFiltersApplied(Object.values(newFilters).some((value) => value !== ""));
  };

  const handleResetFilters = () => {
    setFilters({});
    setFiltersApplied(false);
    setFilterDel(false);
    setFilterCus(false);
    setFilterOrder(false);
    setFilterCol(false);
    setFilterBill(false);
    setFilterTax(false);
    resetAllcus();
    resetAlldel();
    resetAllcol();
    resetAllbill();
    resetAlltax();
    resetAllOrder();
  };
  return (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        {columns.map((column) => {
          return null;
        })}

        {filtersApplied ||
          filterDel ||
          filterCol ||
          filterBill ||
          filterTax ||
          filterOrder}
      </div>
      <div
        style={{
          height: "auto",
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          page={page}
          pageSize={pageSize}
          disableSelectionOnClick={disableSelectionOnClick}
          checkboxSelection={checkboxSelection}
          components={{ Toolbar: GridToolbar }}
          onPaginationModelChange={onPaginationModelChange}
          paginationModel={paginationModel}
          onPageSizeChange={onPageSizeChange}
          pageSizeOptions={pageSizeOptions}
          filterMode="server"
          onFilterModelChange={onFilterModelChange}
          sortingMode="server"
          onSortModelChange={onSortModelChange}
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              textAlign: "left",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              textAlign: "left",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell": {
              textAlign: "left",
            },
            "& .MuiDataGrid-cell.Mui-selected": {
              border: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-tooltip": {
              display: "none",
            },
          }}
        />
      </div>
    </>
  );
};

export default CustomTable;
